// extracted by mini-css-extract-plugin
module.exports = {"comment__reaction-button--active":"ReactionButton_comment__reaction-button--active__AX2ad"};